const MAX_QUERY_LENGTH = 200;

export { MAX_QUERY_LENGTH };
//# sourceMappingURL=limits.js.map
